import {styled} from '@mui/material/styles';
import {DialogContent as MIUDialogContent} from "@mui/material";

export const DialogContent = styled(MIUDialogContent)(() => ({
  overflow: "overlay",
  maxHeight: "526px",  
}))